<div class="comm-list">
  <div class="comm-item" *ngFor="let msg of comunicacoes">
    <div class="comm-header">
      <div
        class="comm-type"
        [class.comm-type--whatsapp]="msg.canal === 'WHATSAPP'"
        [class.comm-type--email]="msg.canal === 'EMAIL'"
      >
        <span class="comm-icon" *ngIf="msg.canal === 'WHATSAPP'">📱</span>
        <span class="comm-icon" *ngIf="msg.canal === 'EMAIL'">✉️</span>
        <span>{{ msg.canal }}</span>
      </div>
      <small class="comm-date">{{ msg.dataHora | date: 'dd/MM HH:mm' }}</small>
    </div>
    <div class="comm-to">Para: {{ msg.para }}</div>
    <p class="comm-message">{{ msg.mensagem }}</p>
    <small class="comm-status">Status: {{ msg.statusEnvio }}</small>
  </div>
</div>
